import { z } from 'zod';

export const PRODUCT_INSIGHT_APP_ID = 'deepresearch';
export const PRODUCT_INSIGHT_PROJECT = 'dp-rsh-reflex';
export const PRODUCT_INSIGHT_SDK = 'pi3-typescript';
export const PRODUCT_INSIGHT_SDK_VERSION = '1.1.1';
export const PRODUCT_INSIGHT_SCHEMA_VERSION = '3.0.0';

export const productInsightHeaderSchema = z
  .object({
    'event-id': z.string(),
    'event-name': z.string(),
    'event-sent-timestamp': z.iso.datetime(),
    'event-user-id': z.string(),
    'event-project': z.string(),
    'event-session-id': z.string().optional(),
  })
  .strict();

export const productInsightSdkSchema = z
  .object({
    'pi-sdk': z.literal(PRODUCT_INSIGHT_SDK),
    'pi-sdk-version': z.literal(PRODUCT_INSIGHT_SDK_VERSION),
    'schema-version': z.literal(PRODUCT_INSIGHT_SCHEMA_VERSION),
  })
  .strict();

export const productInsightApplicationSchema = z
  .object({
    browser: z.string().optional(),
    'browser-version': z.string().optional(),
    os: z.string().optional(),
    'os-version': z.string().optional(),
    'user-agent': z.string().optional(),
    'device-type': z.string(),
  })
  .strict();

export const productInsightNonPiiDataSchema = z
  .object({
    'app-id': z.literal(PRODUCT_INSIGHT_APP_ID),
    event: z.string(),
    constant: z.string(),
    tracker: z.string(),
    properties: z.record(z.string(), z.unknown()),
  })
  .strict();

export const productInsightEventSchema = z
  .object({
    header: productInsightHeaderSchema,
    sdk: productInsightSdkSchema,
    application: productInsightApplicationSchema,
    body: z
      .object({
        'non-pii-data': productInsightNonPiiDataSchema,
        'pii-data': z.record(z.string(), z.unknown()),
      })
      .strict(),
  })
  .strict();

export const productInsightRequestSchema = z
  .object({
    events: z.array(productInsightEventSchema).min(1),
  })
  .strict();

export const lsegAnalyticsProxy = {
  ingest: {
    path: 'lseg-analytics-proxy/v1/ingest',
  },
} as const;

export type ProductInsightEvent = z.infer<typeof productInsightEventSchema>;
export type ProductInsightRequest = z.infer<typeof productInsightRequestSchema>;
export type ProductInsightApplication = z.infer<
  typeof productInsightApplicationSchema
>;
